<div class="row w-100 pt-3 row-title">
    <div class="bold-text blue-color text-center w-100 pb-3 proc-title">Annuler changement de forfait</div>
    <div class="col-12 w-100">
        <div class="w-100 pt-3">
            @if (portabilityDate == null) {
                <div>
                    Je souhaite annuler le changement de forfait prévu au début du mois prochain et garder mon forfait
                    actuel.
                </div>
            }
            @if (portabilityDate != null) {
                <div>
                    Je souhaite <strong>annuler le changement</strong> de forfait prévu en
                    <strong>{{ getMonth() }}</strong> et garder mon forfait actuel.
                </div>
            }
            <br>
            <div class="bold-text">Forfait actuel : <span class="offer-name">{{ line.offer.labelTunnel }}</span></div>
            <br><br>
            @if (line.offer.id > environment.data.minOfferId) {
                <app-shunters [shunters]="getShunters(offerDetails)"></app-shunters>
            }
            @if (portabilityDate != null) {
                <div class="pt-3">
                    @if (differenceInDays > 3) {
                        <div>
                            Cela annulera aussi le changement de réseau. <strong>Vous continuerez à utiliser votre carte
                            SIM actuelle sur le réseau Orange</strong>. Si vous recevez la carte SIM SFR (gratuite),
                            vous pourrez la jeter.
                        </div>
                    }
                    @if (differenceInDays <= 3) {
                        <div>
                            Il n’est plus possible d’annuler le changement de réseau, <strong>votre carte SIM SFR
                            s’activera le {{ portabilityDate }}.</strong>
                        </div>
                    }
                </div>
            }
            <div class="w-100 pt-3 text-center cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                </button>
            </div>
        </div>
    </div>
</div>
